import ROUTES_CONSTANTS from '@src/constants/route-constants.js'

export const DOMAIN_TITLE = 'MyQampus'
export const API_URL = process.env.VUE_APP_API_URL || 'be.dev.myqampus.com'
export const URL_SCHEME = process.env.VUE_APP_URL_SCHEME || 'https'
export const SOCKET_SCHEME = URL_SCHEME === 'https' ? 'wss' : 'ws'
export const BASE_API_URL = process.env.VUE_APP_BASE_API_URL || `${URL_SCHEME}://${API_URL}`
export const FEATURES_ENVIRONMENT = process.env.VUE_APP_FEATURES_ENVIRONMENT || 'prod'
export const ADMIN_API_URL = '/api/v1/'
export const TENNAT_API_URL = '/t_api/v1/'
export const TEAM_TENNAT_API_URL = '/tt_api/v1/'
export const VUE_APP_I18N_LOCALE = 'en'
export const VUE_APP_I18N_FALLBACK_LOCALE = 'en'

// TAWK.TO CONFIGS
export const TAWK_TO_CONFIGS = {
  propertyId: process.env.VUE_APP_TAWK_TO_PROPERTY_ID || '64ff0582b1aaa13b7a7632ca',
  widgetId: process.env.VUE_APP_TAWK_TO_WIDGET_ID || '1ha22r1qq',
}

// IOS NOTIFICATIONS
export const WEB_PUSH_VAPID_PUBLIC_KEY =
  process.env.VUE_APP_IOS_WEB_PUSH_VAPID_PUBLIC_KEY ||
  'BFu4r04yG72CKDCBNsYcn-bSPThgNERc27kIiikzv6YUpConOwVAyeHdZN6WMXhoc67gQgA1lCHargGKtYHFGTA'

export const PROD_FEATURES = [
  ROUTES_CONSTANTS.DASHBOARD.NAME,
  ROUTES_CONSTANTS.QUICK_ACTION.NAME,
  ROUTES_CONSTANTS.CAMPUSES.NAME,
  ROUTES_CONSTANTS.USERS.SUPER_ADMIN.NAME,
  ROUTES_CONSTANTS.USERS.CAMPUS_ADMIN.NAME,
  ROUTES_CONSTANTS.USERS.STAFF.NAME,
  ROUTES_CONSTANTS.USERS.TEACHERS.NAME,
  ROUTES_CONSTANTS.USERS.STUDENTS.NAME,
  ROUTES_CONSTANTS.USERS.GUARDIANS.NAME,
  ROUTES_CONSTANTS.USERS.PICKUP_PERSONS.NAME,
  ROUTES_CONSTANTS.USERS.ALL_USERS.NAME,
  ROUTES_CONSTANTS.ATTENDANCE.STAFF.NAME,
  ROUTES_CONSTANTS.SYLLABUS_MANAGER.NAME,
  ROUTES_CONSTANTS.SYLLABUS_MANAGER.SUBJECTS.NAME,
  ROUTES_CONSTANTS.SYLLABUS_MANAGER.CHAPTERS.NAME,
  ROUTES_CONSTANTS.SYLLABUS_MANAGER.TOPICS.NAME,
  ROUTES_CONSTANTS.SYLLABUS_MANAGER.LESSONS.NAME,
  ROUTES_CONSTANTS.CLASSES.NAME,
  ROUTES_CONSTANTS.PICKUP_REQUEST_MANAGER.FACILITY_ACTIVE_REQUESTS.NAME,
  ROUTES_CONSTANTS.PICKUP_REQUEST_MANAGER.FACILITY_ALL_REQUESTS.NAME,
  ROUTES_CONSTANTS.TIME_TABLE.LESSON_PLANNER.NAME,
  ROUTES_CONSTANTS.EXAMS_MANAGER.EXAM_TYPES.NAME,
  ROUTES_CONSTANTS.EXAMS_MANAGER.EXAM.NAME,
  ROUTES_CONSTANTS.TIME_TABLE.NAME,
  ROUTES_CONSTANTS.TIME_TABLE.AUTOMATOR.NAME,
  ROUTES_CONSTANTS.TIME_TABLE.CURRENT.NAME,
  ROUTES_CONSTANTS.ATTENDANCE.CAMPUS.NAME,
  ROUTES_CONSTANTS.ATTENDANCE.SECTION.NAME,
  ROUTES_CONSTANTS.ATTENDANCE.PERIOD.NAME,
  ROUTES_CONSTANTS.FEE_MANAGER.NAME,
  ROUTES_CONSTANTS.FEE_MANAGER.ACCEPT_PAYMENT.NAME,
  ROUTES_CONSTANTS.FEE_MANAGER.PAYABLE.NAME,
  ROUTES_CONSTANTS.FEE_MANAGER.PAID.NAME,
  ROUTES_CONSTANTS.FEE_MANAGER.FEE_TYPES.NAME,
  ROUTES_CONSTANTS.FEE_MANAGER.RECEIVABLE.NAME,
  ROUTES_CONSTANTS.FEE_MANAGER.RECEIVED.NAME,
  ROUTES_CONSTANTS.FEE_MANAGER.MONTHLY_FEE_GENERATOR.NAME,
  ROUTES_CONSTANTS.FEE_MANAGER.STUDENT_DISCOUNT_LIST.NAME,
  ROUTES_CONSTANTS.GRADES_MANAGER.SECTION_EXAMS_RESULT.NAME,
  ROUTES_CONSTANTS.TIME_TABLE.MY_TIMETABLE.NAME,
  ROUTES_CONSTANTS.TEACHER_USERS.NAME,
  ROUTES_CONSTANTS.TEACHER_USERS.STUDENT.NAME,
  ROUTES_CONSTANTS.PICKUP_MANAGER.NAME,
  ROUTES_CONSTANTS.NOTICE_BOARD.LABELS.NAME,
  ROUTES_CONSTANTS.NOTICE_BOARD.VIEW.NAME,
  ROUTES_CONSTANTS.TIME_TABLE.STAFF_BIRTHDAYS.NAME,
  ROUTES_CONSTANTS.TIME_TABLE.STUDENT_BIRTHDAYS.NAME,
  'PICKUP_ACTIVE_REQUEST',
  'PICKUP_ALL_REQUEST',
  'SECTION_ATTENDANCE_PERMISSION',
  'SYLLABUS_PERMISSION_SETTINGS',
  'TIME_TABLE_PERMISSION',
  'PERIOD_ATTENDANCE_PERMISSION',
  'CAMPUS_ATTENDANCE_PERMISSION',
  'STUDENTS_PERIOD_ATTANDANCE',
  'CLASS_PERMISSION',
  'SECTION_PERMISSION',
  'FEE',
  'STUDENT_PAYABLE',
  'STUDENT_PAID',
  'TEACHER',
  'ROLES_AND_ACCESS',
  'SECTION',
  'Settings',
  'Fees',
  'Discounts',
  'SECTION_FEE',
  'SECTIONS',
  'Profile',
  'Contact Settings',
  'Theme Settings',
  'Campuses',
  'Staff',
  'DISCOUNT_TYPES',
  'Fee Discounts',
  'FEE_SETTINGS',
  'Profile Settings',
  'perosnal-info',
  'contact-info',
  'professional-info',
  'Fee Notification',
  'Notifications',
  'general-notifications',
  'features-notifications',
  'security-notifications',
  'ROOMS',
  'OWNERSHIP',
  'PICKUP_SETTINGS',
  'SMS_AD_ONS',
  'EMAIL_AD_ONS',
  'STUDENT_NOTIFICATION',
  'Attendance Settings',
  'FEATURE_SETTINGS',
  'Lesson Planner',
  'NON_GPA_GRADE',
  'NON_GPA_GRADE_DETAIL',
  'SUBJECT_RESULT',
  'Section Exams Result',
  'Final Result',
  'subject-result',
  'SUBJECT_SYLLABUS_TEMPLATE',
  'Security Settings',
  'change-password',
  'SYLLABUS_MANAGER_PERMISSION',
  'General Settings',
  'SCHEDULE_SETTINGS',
  'SYLLABUS_AUTOMATOR_PERMISSION',
  'SYLLABUS_TEMPLATE_PROVIDER',
  'LESSON_PLANNER_SETTINGS',
  'EXAM_PLANNER_PERMISSION',
  'Attandance Notification',
  'GUARDIAN_NOTIFICATION',
  'PICKUP_REQUEST_MANAGER',
  'ALL_REQUESTS',
  'ACTIVE_REQUESTS',
  'STUDENT_DISPATCHER',
  'EXAM_PLANNER_PERMISSION',
  'LESSON_PLANNER_SETTINGS',
  'Site Settings',
  'SUPPORT_QUERY_TYPES',
  'SUPPORT_QUERY',
  'ANNOUNCEMENT_TYPES',
  'ANNOUNCEMENTS',
  'SUPPORT_QUERY_PERMISSION',
  'ASSIGNMENT_TYPES',
  'ASSIGNMENTS_DETAILS',
  'ASSIGNMENTS',
  'SUPPORT_QUERY_NOTIFICATION',
  'CAMPUS_ATTENDANCE',
  'PERIOD_ATTENDANCE',
  'SECTION_ATTENDANCE',
  'SYLLABUS_AUTOMATOR',
  'STAFF',
  'LESSON_PLANNER',
  'SUPPORT_QUERY',
  'SECTION',
  'PICKUP_PERSON',
  'STUDENT',
  'STUDENT_PERFORMANCE',
  'STAFF_CAMPUS_ATTENDANCE',
  'billing-payment',
  'FEATURE_MANAGER',
  'NOTIFICATION_PREFERENCES',
]
export const DEV_FEATURES = [
  ...PROD_FEATURES,
  'GPA_GRADE',
  'GPA_GRADE_DETAIL',
  ROUTES_CONSTANTS.ATTENDANCE.DAILY_STUDENT_ATTENDANCE.NAME,
  ROUTES_CONSTANTS.ATTENDANCE.DAILY_STAFF_ATTENDANCE.NAME,
]
export let ALLOWED_FEATURES = []

if (FEATURES_ENVIRONMENT === 'prod') ALLOWED_FEATURES = PROD_FEATURES
else if (FEATURES_ENVIRONMENT === 'dev') ALLOWED_FEATURES = DEV_FEATURES
console.log(process.env, 'process.env')
/**
 * Firebase Configuration
 */

export const firebaseConfig = {
  apiKey: process.env.VUE_APP_FCM_API_KEY || 'AIzaSyC4y7e0_fU3PKkKL81ppH909U9cZDfcMQs',
  authDomain: process.env.VUE_APP_FCM_AUTH_DOMAIN || 'myqampus-dev-ad775.firebaseapp.com',
  projectId: process.env.VUE_APP_FCM_PROJECT_ID || 'myqampus-dev-ad775',
  storageBucket: process.env.VUE_APP_FCM_STORAGE_BUCKET || 'myqampus-dev-ad775.appspot.com',
  messagingSenderId: process.env.VUE_APP_FCM_MESSAGING_SENDER_ID || '810931957090',
  appId: process.env.VUE_APP_FCM_APP_ID || '1:810931957090:web:13ae34df9c6be5a75d903b',
  measurementId: process.env.VUE_APP_FCM_MEASUREMENT_ID || 'G-PD1C01Y845',
}
export const vapidKey =
  process.env.VUE_APP_FCM_VAPID_KEY ||
  'BJhYd6aYMuAIypzvroaAoHLIg-cNWbHguAVEKhunazhBRG1XVssRo26KSvo2pZ42g6jxzeBihqwWYAZz8Tqs-ug'
export const GOOGLE_LOGIN_CLIENT_ID =
  process.env.VUE_APP_GOOGLE_LOGIN_CLIENT_ID ||
  '810931957090-jt4n318qagoknn07mkbbeq1l0b3sspn7.apps.googleusercontent.com'

export const MICROSOFT_LOGIN_CLIENT_ID =
  process.env.VUE_APP_MICROSOFT_LOGIN_CLIENT_ID || '5a9d1bca-11df-470b-aa96-bc6771cfb510'

export const APPLE_LOGIN_CLIENT_ID =
  process.env.VUE_APP_APPLE_LOGIN_CLIENT_ID || 'com.tandembeta.web.app'

export const ALLOWED_FILTERS = [
  'student-lessons',
  'student-topics',
  'student-chapters',
  'student-subjects',
  'tenants',
  'students',
  'staff',
  'teachers',
  'guardians',
  'fee',
  'pickup-feature-settings',
  'campus-attendance',
  'period-attendance',
  'section-attendance',
  'syllabus-automator',
  'staff-feature-settings',
  'syllabus',
  'lesson-planner',
  'teacher',
  'time-table',
  'class',
  'support-query',
  'section',
  'exam-planner',
  'pickup-person',
  'student',
  'topics',
  'subjects',
  'all-users',
  'receivable',
  'announcement',
  'syllabus-template-course',
  'syllabus-template',
  'chapters',
  'section',
  'period',
  'facility-active-request',
  'facility-all-requests',
  'lessons',
  'pickup-person',
  'received',
  'student-campus-attendance',
  'announcement-types',
  'guardians',
  'support-user-active-request',
  'facility-user-all-requests',
  'student-fee-receivable',
  'student-fee-received',
  'student-paid',
  'student-discounts',
  'payable',
  'section-result',
  'exams',
  'class-notification',
  'rooms',
  'classes',
  'campus-admin',
  'monthly-fee-generator',
  'fee-types',
  'exam-types',
  'section-notification',
  'super-admin',
  'discount-types',
  'subject-result',
  'non-gpa-grading-structure',
  'gpa-grading-structure',
  'student-section-attendance',
  'facility-user-active-request',
  'fee-notification-settings',
  'students-period-attendance',
  'campus-attendance-notification',
  'support-active-request',
  'section-attendance-notification',
  'sections',
  'teacher-notification-settings',
  'staff-notification',
  'pickup-person-notification',
  'student-notification-settings',
  'period-attendance-notification',
  'syllabus-manager-notification',
  'syllabus-automator-notification',
  'campuses',
  'pickup-manager-notification',
  'subject-syllabus-template',
  'assignment-types',
  'assignmens-view',
  'assignmens-detail-view',
  'support-query-notification-settings',
  'staff-campus-attendance',
  'daily-student-attendance',
  'daily-staff-attendance',
]
